import './SimplePagination.scss';
import classNames from 'classnames';
import { PaginationDirection } from '@sonar-software/sonar-ts-types';
import { When } from 'react-if';
import { Button, Select } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import React, { useState } from 'react';

const pageSizeOptions = [
	{
		label: '10 / page',
		value: 10
	},
	{
		label: '20 / page',
		value: 20
	},
	{
		label: '50 / page',
		value: 50
	},
	{
		label: '100 / page',
		value: 100
	}
];

export interface SimplePaginationProps {
	autoHide?: boolean;
	className?: string;
	defaultPageSize?: number;
	enableNext?: boolean;
	enablePrev?: boolean;
	onChange: (pageSize: number, direction?: PaginationDirection) => void;
	showSizeChanger?: boolean;
}

export const SimplePagination: React.FC<SimplePaginationProps> = ({
	autoHide,
	className,
	defaultPageSize = 20,
	enableNext,
	enablePrev,
	onChange,
	showSizeChanger = true
}) => {
	const [ pageSize, setPageSize ] = useState(defaultPageSize);

	if (autoHide && !enableNext && !enablePrev) {
		return null;
	}

	return (
		<div className={ classNames('simple-pagination', className) }>
			<Button
				disabled={ !enablePrev }
				icon={ <LeftOutlined /> }
				onClick={ () => onChange(pageSize, PaginationDirection.Backward) }
				size='middle' />
			<Button
				disabled={ !enableNext }
				icon={ <RightOutlined /> }
				onClick={ () => onChange(pageSize, PaginationDirection.Forward) }
				size='middle' />
			<When condition={ showSizeChanger }>
				<Select
					defaultValue={ defaultPageSize }
					onChange={ (value) => {
						setPageSize(value);
						onChange(value);
					} }
					options={ pageSizeOptions } />
			</When>
		</div>
	);
};
